<template>
  <div class="page">
    <h1 v-if="currentUser">Logged in</h1>
    <h1 v-else>Log in above</h1>
  </div>
</template>

<script>
import UserSignin from "@/components/UserSignin";

export default {
  components: {
    UserSignin
  }
};
</script>

<style scoped lang="less">
@import "../styles/vars";
</style>
